import { SaleWindow } from "nvs-types/dist/types/generated/contentful";
import { getTimeUntilDateTime } from "../components/CountdownClock/helpers";
import { CountdownType, Countdowns } from "../components/CountdownClock/types";
import { formatDateTimeString, sortItemsByDateTime } from "./dateTime";
import { getAllSales } from "./saleWindows";
import { getUniqueArray } from "@/libs/utils";
import { isNil } from "lodash";

export function getCountdownsFromSaleWindows(saleWindows: SaleWindow[]) {
  const formattedCountdowns = formatCountdownsFromSaleWindows(saleWindows);
  return getUniqueAndSortedCountdowns(formattedCountdowns);
}

export function getCountdownsFromDateTimes(dateTimes: string[], copy?: string) {
  const formattedCountdowns = formatCountdownsFromDateTimes(dateTimes, copy);
  return getUniqueAndSortedCountdowns(formattedCountdowns);
}

export function formatCountdownsFromSaleWindows(saleWindows: SaleWindow[]) {
  const allSales = getAllSales(saleWindows);

  const countdowns: Countdowns = allSales.map((sale) => {
    const countdownCopy = `${sale.title} ${sale.type}: ${formatDateTimeString(
      sale.dateTime,
    )}`;

    const countdown: CountdownType = {
      copy: countdownCopy,
      dateTime: sale.dateTime,
    };

    return countdown;
  });

  return countdowns;
}

export function formatCountdownsFromDateTimes(
  dateTimes: string[],
  copy?: string,
) {
  const countdowns: Countdowns = dateTimes.map((dateTime) => {
    const countdownCopy = `${copy && copy + ": "}${formatDateTimeString(
      dateTime,
    )}`;

    const countdown: CountdownType = {
      copy: countdownCopy,
      dateTime: dateTime,
    };

    return countdown;
  });

  return countdowns;
}

export function getUniqueAndSortedCountdowns(countdowns: CountdownType[]) {
  const uniqueCountdowns = getUniqueArray(countdowns, ["dateTime"]);
  const sortedCountdowns = sortItemsByDateTime(uniqueCountdowns);
  return sortedCountdowns as CountdownType[];
}

export const isCountdownActive = (countdowns?: CountdownType[] | null) => {
  if (isNil(countdowns)) return true; // if no reveal dates, do not show reveal
  const available = countdowns?.some((countdown) =>
    getTimeUntilDateTime(countdown.dateTime),
  );

  return available;
};
